/**
 * Loaded 3D models of custom objects, by asset id: one download and parse
 * per model; every placed object gets a clone sharing the geometry and
 * materials.
 */

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

const cache = new Map<string, Promise<THREE.Object3D>>();

export function loadCustomModel(assetId: string, url: string): Promise<THREE.Object3D> {
  let pending = cache.get(assetId);
  if (!pending) {
    pending = new GLTFLoader().loadAsync(url).then((gltf) => gltf.scene);
    // A failed download may succeed later (fresh SAS, network back).
    pending.catch(() => cache.delete(assetId));
    cache.set(assetId, pending);
  }
  return pending;
}

/** Seed the cache with a model already in memory (just imported in the editor). */
export function primeCustomModel(assetId: string, object: THREE.Object3D): void {
  cache.set(assetId, Promise.resolve(object));
}

/** A placeable copy: shared geometry/materials, own transforms. */
export async function cloneCustomModel(assetId: string, url: string): Promise<THREE.Object3D> {
  return (await loadCustomModel(assetId, url)).clone(true);
}
